export default __webpack_public_path__ + "static/media/ethereum-chain-logo.badcd743.png";